import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';

export function gAChangePPSelectPackageLimited(count) {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_SELECT_FOR_LIMITED_Y_PAGE.category,
    gaParams.CHANGE_PRICE_PLAN_SELECT_FOR_LIMITED_Y_PAGE.eventType,
    count
  );
}
export function gAChangePPOrderBtnClickLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_CLICK_ORDER_BTN_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_CLICK_ORDER_BTN_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_CLICK_ORDER_BTN_FOR_LIMITED.eventParams
  );
}

export function gAChangePPOrderBtnClick() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_CLICK_SELECT_NEW_PLAN.category,
    gaParams.CHANGE_PRICE_PLAN_CLICK_SELECT_NEW_PLAN.eventType,
    gaParams.CHANGE_PRICE_PLAN_CLICK_SELECT_NEW_PLAN.eventParams
  );
}
export function gAChangePPContinueBtnClickLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_CONTINUE_POPUP_CONTINUE_PROCESS_CLICK_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_CONTINUE_POPUP_CONTINUE_PROCESS_CLICK_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_CONTINUE_POPUP_CONTINUE_PROCESS_CLICK_FOR_LIMITED.eventParams
  );
}
export function gAChangePPContinueBtnClick() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_CONTINUE_POPUP_CONTINUE_PROCESS_CLICK.category,
    gaParams.CHANGE_PRICE_PLAN_CONTINUE_POPUP_CONTINUE_PROCESS_CLICK.eventType,
    gaParams.CHANGE_PRICE_PLAN_CONTINUE_POPUP_CONTINUE_PROCESS_CLICK.eventParams
  );
}

export function gAChangePPContractBySmsLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_SMS_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_SMS_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_SMS_FOR_LIMITED.eventParams
  );
}
export function gAChangePPContractByMailLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_MAIL_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_MAIL_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_MAIL_FOR_LIMITED.eventParams
  );
}
export function gAChangePPContractByMail() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_MAIL.category,
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_MAIL.eventType,
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_MAIL.eventParams
  );
}

export function gAChangePPContractBySms() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_SMS.category,
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_SMS.eventType,
    gaParams.CHANGE_PRICE_PLAN_SEND_CONTRACT_SMS.eventParams
  );
}
export function gAChangePPContractPageLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_CONTRACT_SENDING_PAGE_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_CONTRACT_SENDING_PAGE_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_CONTRACT_SENDING_PAGE_FOR_LIMITED.eventParams
  );
}
export function gAChangePPContractPage() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_CONTRACT_SENDING_PAGE.category,
    gaParams.CHANGE_PRICE_PLAN_CONTRACT_SENDING_PAGE.eventType,
    gaParams.CHANGE_PRICE_PLAN_CONTRACT_SENDING_PAGE.eventParams
  );
}

export function gAChangePPBundleError() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_BUNDLE_ERROR.category,
    gaParams.CHANGE_PRICE_PLAN_BUNDLE_ERROR.eventType,
    gaParams.CHANGE_PRICE_PLAN_BUNDLE_ERROR.eventParams
  );
}

export function gAChangePPSubStatusError() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_ERROR.category,
    gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_ERROR.eventType,
    gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_ERROR.eventParams
  );
}
export function gAChangePPNotAvailableForLimitedError() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_ERROR.category,
    gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_ERROR.eventType,
    gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_ERROR.eventParams
  );
}
export function gAChangePPErrorOnChangeLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_FOR_LIMITED.eventParams
  );
}
export function gAChangePPErrorOnChange() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE.category,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE.eventType,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE.eventParams
  );
}

export function gAChangePPServerError() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_SERVER_ERROR.category,
    gaParams.CHANGE_PRICE_PLAN_SERVER_ERROR.eventType,
    gaParams.CHANGE_PRICE_PLAN_SERVER_ERROR.eventParams
  );
}
export function gAChangePPBundleCallBackRequestFailed() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST_FAILED.category,
    gaParams.CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST_FAILED.eventType,
    gaParams.CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST_FAILED.eventParams
  );
}
export function gAChangePPSubStatusCallBackRequestFailed() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST_FAILED.category,
    gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST_FAILED.eventType,
    gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST_FAILED.eventParams
  );
}

export function gAChangePPNotAvailableForLimitedCallBackRequestFailed() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST_FAILED.category,
    gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST_FAILED.eventType,
    gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST_FAILED.eventParams
  );
}
export function gAChangePPCallBackRequestFailedForLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FAILED_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FAILED_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FAILED_FOR_LIMITED.eventParams
  );
}

export function gAChangePPCallBackRequestFailed() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FAILED.category,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FAILED.eventType,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FAILED.eventParams
  );
}

export function gAChangePPBundleCallBackRequest() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST.category,
    gaParams.CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST.eventType,
    gaParams.CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST.eventParams
  );
}
export function gAChangePPSubStatusCallBackRequest() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST.category,
    gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST.eventType,
    gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST.eventParams
  );
}
export function gAChangePPNotAvailableForLimitedCallBackRequest() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST.category,
    gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST.eventType,
    gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST.eventParams
  );
}

export function gAChangePPCallBackRequestForLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_FOR_LIMITED.eventParams
  );
}
export function gAChangePPCallBackRequest() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST.category,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST.eventType,
    gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST.eventParams
  );
}

export function gAChangePPConfirmationComponent() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_CONFIRMATION_CMP.category,
    gaParams.CHANGE_PRICE_PLAN_CONFIRMATION_CMP.eventType,
    gaParams.CHANGE_PRICE_PLAN_CONFIRMATION_CMP.eventParams
  );
}
export function gAChangePPConfirmationComponentReselectPackageLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_RESELECT_NEW_PLAN_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_RESELECT_NEW_PLAN_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_RESELECT_NEW_PLAN_FOR_LIMITED.eventParams
  );
}
export function gAChangePPConfirmationComponentReselectPackage() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_RESELECT_NEW_PLAN.category,
    gaParams.CHANGE_PRICE_PLAN_RESELECT_NEW_PLAN.eventType,
    gaParams.CHANGE_PRICE_PLAN_RESELECT_NEW_PLAN.eventParams
  );
}
export function gAChangePPOpenPlansForLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_OPEN_PLANS_PAGE_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_OPEN_PLANS_PAGE_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_OPEN_PLANS_PAGE_FOR_LIMITED.eventParams
  );
}
export function gAChangePPUserHasNotCellularPlan() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_ERROR_USER_HAS_NOT_CELLULAR_PLANS.category,
    gaParams.CHANGE_PRICE_PLAN_ERROR_USER_HAS_NOT_CELLULAR_PLANS.eventType,
    gaParams.CHANGE_PRICE_PLAN_ERROR_USER_HAS_NOT_CELLULAR_PLANS.eventParams
  );
}
export function gAChangePPTypeError() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_ACCOUNT_TYPE_ERROR.category,
    gaParams.CHANGE_PRICE_PLAN_ACCOUNT_TYPE_ERROR.eventType,
    gaParams.CHANGE_PRICE_PLAN_ACCOUNT_TYPE_ERROR.eventParams
  );
}
export function gAChangePPModemError() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_SUB_MODEM_ERROR.category,
    gaParams.CHANGE_PRICE_PLAN_SUB_MODEM_ERROR.eventType,
    gaParams.CHANGE_PRICE_PLAN_SUB_MODEM_ERROR.eventParams
  );
}
export function gAChangePPFuturePPError() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_FUTURE_PP_ERROR.category,
    gaParams.CHANGE_PRICE_PLAN_FUTURE_PP_ERROR.eventType,
    gaParams.CHANGE_PRICE_PLAN_FUTURE_PP_ERROR.eventParams
  );
}
export function gAChangePPSamePlanError() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_THE_SANE_PLAN_ERROR.category,
    gaParams.CHANGE_PRICE_PLAN_THE_SANE_PLAN_ERROR.eventType,
    gaParams.CHANGE_PRICE_PLAN_THE_SANE_PLAN_ERROR.eventParams
  );
}
export function gAChangePPFailedPartLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_ERROR_FAILED_PART_OF_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_ERROR_FAILED_PART_OF_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_ERROR_FAILED_PART_OF_FOR_LIMITED.eventParams
  );
}

export function gAChangePPWarningPage() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_WARNING_PAGE.category,
    gaParams.CHANGE_PRICE_PLAN_WARNING_PAGE.eventType,
    gaParams.CHANGE_PRICE_PLAN_WARNING_PAGE.eventParams
  );
}

export function gAChangePPWarningPageContinueClick() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_WARNING_PAGE_CONTINUE_CLICK.category,
    gaParams.CHANGE_PRICE_PLAN_WARNING_PAGE_CONTINUE_CLICK.eventType,
    gaParams.CHANGE_PRICE_PLAN_WARNING_PAGE_CONTINUE_CLICK.eventParams
  );
}
export function gAChangePPWarningPageCancelClick() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_WARNING_PAGE_CANCEL_CLICK.category,
    gaParams.CHANGE_PRICE_PLAN_WARNING_PAGE_CANCEL_CLICK.eventType,
    gaParams.CHANGE_PRICE_PLAN_WARNING_PAGE_CANCEL_CLICK.eventParams
  );
}
export function gAChangePPSuccessPageLimited() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_CHANGE_SUCCEEDED_FOR_LIMITED.category,
    gaParams.CHANGE_PRICE_PLAN_CHANGE_SUCCEEDED_FOR_LIMITED.eventType,
    gaParams.CHANGE_PRICE_PLAN_CHANGE_SUCCEEDED_FOR_LIMITED.eventParams
  );
}
export function gAChangePPSuccessPage() {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_CHANGE_SUCCEEDED.category,
    gaParams.CHANGE_PRICE_PLAN_CHANGE_SUCCEEDED.eventType,
    gaParams.CHANGE_PRICE_PLAN_CHANGE_SUCCEEDED.eventParams
  );
}
export function gAChangePPSubscribersCount(length) {
  gaEvent(
    gaParams.CHANGE_PRICE_PLAN_EXISTED_SUBSCRIBERS_COUNT.category,
    gaParams.CHANGE_PRICE_PLAN_EXISTED_SUBSCRIBERS_COUNT.eventType,
    length
  );
}
